import api from "./api";

export const webhooksService = {
  list(params) {
    return api.get("/webhooks", { params });
  },
  get(id) {
    return api.get(`/webhooks/${id}`);
  },
  create(payload) {
    return api.post("/webhooks", payload);
  },
  update(id, payload) {
    return api.patch(`/webhooks/${id}`, payload);
  },
  remove(id) {
    return api.delete(`/webhooks/${id}`);
  },
  getLogs(id, params) {
    return api.get(`/webhooks/${id}/logs`, { params });
  },
};
